(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-eu-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    let trigger;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#fs-eu-notice"]');
      const dialog = document.getElementById('fs-eu-notice');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (link) {
        event.preventDefault();
        trigger = link;
        if (!dialog.open) dialog.showModal();
        dialog.scrollTop = 0;
      }
      if (event.target.closest('[data-fs-eu-close]')) {
        event.preventDefault();
        dialog.close();
        if (location.hash === '#fs-eu-notice') history.replaceState(null, '', location.pathname + location.search);
        trigger?.focus();
      }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    const dialog = document.getElementById('fs-eu-notice');
    dialog?.addEventListener('close', () => trigger?.focus());
    if (location.hash === '#fs-eu-notice' && dialog && typeof dialog.showModal === 'function') {
      history.replaceState(null, '', location.pathname + location.search);
      dialog.showModal();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
